import { Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsBoost from 'highcharts/modules/boost';
import { IGaugeGraph } from '../../../interfaces/charts/trader-advisor.interface';

@Component({
	selector: 'traderadvisor-gauge',
	templateUrl: './traderadvisor-gauge.component.html',
	styleUrls: ['./traderadvisor-gauge.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class TraderadvisorGaugeComponent implements OnChanges {
	@Input() public options: IGaugeGraph;

	constructor() {
		HighchartsBoost(Highcharts);
		HighchartsMore(Highcharts);
	}

	ngOnChanges() {
		if(this.options) {
			Highcharts.chart('hc-gauge', {
				chart: {
					type: 'gauge',
					plotBackgroundColor: null,
					plotBackgroundImage: null,
					plotBorderWidth: 0,
					plotShadow: false,
					height: '150'
				},
				title: {
					text: '',
				},
				lang: {
					noData: 'Sem dados para exibir'
				},
				pane: {
					startAngle: -110,
					endAngle: 109.9,
					background: null,
					center: ['50%', '75%'],
					size: '150%'
				},

				yAxis: {
					min: this.options.yAxis.min,
					max: this.options.yAxis.max,
					tickPixelInterval: 72,
					tickPosition: 'inside',
					tickColor: Highcharts.defaultOptions.chart.backgroundColor || '#FFFFFF',
					tickLength: 20,
					tickWidth: 2,
					minorTickInterval: null,
					labels: {
						enabled: false,
						distance: 20,
						style: {
							fontSize: '14px'
						}
					},
					plotBands: [{
						from: this.options.yAxis.plotBands.red.from,
						to: this.options.yAxis.plotBands.red.to,
						color: '#F02733',
						thickness: 20
					}, {
						from: this.options.yAxis.plotBands.lightred.from,
						to: this.options.yAxis.plotBands.lightred.to,
						color: '#FF8990',
						thickness: 20
					}, {
						from: this.options.yAxis.plotBands.lightgreen.from,
						to: this.options.yAxis.plotBands.lightgreen.to,
						color: '#00E8BE',
						thickness: 20
					}, {
						from: this.options.yAxis.plotBands.green.from,
						to: this.options.yAxis.plotBands.green.to,
						color: '#00C898',
						thickness: 20
					}]
				},

				plotOptions: {
					gauge: {
						dial: {
							radius: '70%',
							backgroundColor: '#D2D5D8',
							baseWidth: 12,
							baseLength: '0%',
							rearLength: '0%'
						},
						pivot: {
							backgroundColor: '#D2D5D8',
							radius: 6
						}
					}
				},

				series: [{
					name: 'APPT',
					type: "gauge",
					data: [this.options.data],
					dataLabels: {
						enabled: false,
						formatter: function() {
							return this.y.toString().replace('.', ',');
						},
						borderWidth: 0,
						color: (
							Highcharts.defaultOptions.title &&
							Highcharts.defaultOptions.title.style &&
							Highcharts.defaultOptions.title.style.color
						) || '#333333',
						style: {
							fontSize: '32px'
						}
					},
				}]
			});
		}
	}
}
